module.exports = __webpack_public_path__ + "img/1.7f5b13f1.png";